module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("Farrar, Straus and Giroux"), _c('br'), _vm._v("19 Union Square West, New York 10003")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Copyright © 2006 by Tom Lutz"), _c('br'), _vm._v("All rights reserved"), _c('br'), _vm._v("Distributed in Canada by Douglas & McIntyre Ltd."), _c('br'), _vm._v("Printed in the United States of America"), _c('br'), _vm._v("Published in 2006 by Farrar, Straus and Giroux"), _c('br'), _vm._v("First paperback edition, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("The Library of Congress has cataloged the hardcover edition as follows:"), _c('br'), _vm._v("              Lutz, Tom."), _c('br'), _vm._v("                     Doing nothing : a history of loafers, loungers, slackers and bums in"), _c('br'), _vm._v("                 America / Tom Lutz.— 1st ed."), _c('br'), _vm._v("                        p. cm."), _c('br'), _vm._v("                     Includes bibliographical references."), _c('br'), _vm._v("                     ISBN-13: 978-0-86547-650-9 (hardcover : alk. paper)"), _c('br'), _vm._v("                     ISBN-10: 0-86547-650-0 (hardcover : alk. paper)"), _c('br'), _vm._v("                     1. Slackers—United States—History. 2. Laziness—United States—"), _c('br'), _vm._v("                 History. I. Title."), _c('br'), _vm._v("                 BJ1498.L88 2006"), _c('br'), _vm._v("                 174—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("2005027230")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Paperback ISBN-13: 978-0-86547-737-7"), _c('br'), _vm._v("Paperback ISBN-10: 0-86547-737-X")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Designed by Debbie Glasserman")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.fsgbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fsgbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("1   3   5   7   9   10   8   6   4   2")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d18f06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780865477377_epub_cop_r1.vue
// module id = 66
// module chunks = 0